import React from 'react'
import moment from 'moment'
import { FormattedMessage } from '@dragonraider5/react-intl'
import { showFieldError, renderValidation } from '../../../../../utils/validations'
import { getExceptionMessage } from '../../../../../utils/exceptions'
import validationMessages from './validationMessages'

export const getYearPeriod = ({
  startPeriod,
  endPeriod
}) => {
  const minDate = moment().month(startPeriod.month).date(startPeriod.date)
  const maxDate = moment().month(endPeriod.month).date(endPeriod.date).add(2, 'weeks')
  const now = moment()
  const nowYear = now.year()

  if (now.isBefore(minDate)) {
    return nowYear - 2
  }
  if (now.isBetween(minDate, maxDate)) {
    return [nowYear - 1, nowYear - 2]
  }
  return nowYear - 1
}

export const callAll = (...fns) => (...args) => fns.forEach(fn => fn && fn(...args))

export const hasUploadError = (field, { errors, touched, status, submitError }) => (
  showFieldError(field, { errors, touched }) ||
  !!status.error ||
  !!submitError
)
export const renderUploadError = (field, { errors, touched, status, submitError }) => {
  if (showFieldError(field, { errors, touched })) {
    return renderValidation(field, { errors, touched }, validationMessages)
  }
  if (status.error) {
    return (
      <FormattedMessage
        {...getExceptionMessage(status.error || submitError)}
      />
    )
  }

  if (!!submitError) {
    return (
      <FormattedMessage
        {...validationMessages.requiredDocument}
      />
    )
  }
  return null
}
